module.exports = __webpack_public_path__ + "static/pos-8116cb6612ff60520d037b5402ac6ed6.jpg";